<template>
  <div class="helmi-search-watch-fields">
    <helmi-chips
      id="target_type"
      v-model="items.target_type"
      :container-options="{
        cols: 12,
        class: 'py-1',
      }"
      :options="target_types"
      :colors="colors"
      :label-colors="labelColors"
      :numeric="numericFields.includes('target_type')"
      icon="rule"
      label="Kohde"
    />

    <helmi-chips
      id="property_type"
      v-model="items.property_types"
      :container-options="{
        cols: 12,
        class: 'py-1',
      }"
      :options="property_types"
      :additional-options="additional_property_types"
      :colors="colors"
      :label-colors="labelColors"
      :numeric="numericFields.includes('property_type')"
      icon="home_work"
      label="Kohdetyyppi"
      label-additional-options="Muut kohdetyypit"
      multiple
    />

    <helmi-combo-box
      id="cities"
      v-model="items.cities"
      :container-options="{
        cols: 12,
        class: 'py-1',
      }"
      :colors="colors"
      :label-colors="labelColors"
      icon="place"
      label="Kaupunki tai postinumero"
      multiple
    />

    <helmi-range-slider
      id="rooms"
      v-model="items.rooms"
      :container-options="{
        cols: 12,
        class: 'py-1',
      }"
      :colors="colors"
      :label-colors="labelColors"
      icon="room_preferences"
      label="Huoneluku"
      min="0"
      max="10"
      suffix="kpl"
      step="1"
    />

    <helmi-range-slider
      id="area"
      v-model="items.area"
      :container-options="{
        cols: 12,
        class: 'py-1',
      }"
      :colors="colors"
      :label-colors="labelColors"
      icon="square_foot"
      label="Pinta-ala"
      min="0"
      max="500"
      suffix="m2"
      step="10"
    />

    <helmi-range-slider
      id="price"
      v-model="items.price"
      :container-options="{
        cols: 12,
        class: 'py-1',
      }"
      :colors="colors"
      :label-colors="labelColors"
      :max="maxPrice"
      :step="stepPrice"
      :step-options="stepOptionsPrice"
      icon="money"
      label="Hinta"
      min="0"
      suffix="€"
    />

    <helmi-chips
      id="requirements"
      v-model="items.requirements"
      :container-options="{
        cols: 12,
        class: 'py-1',
      }"
      :options="requirements"
      :colors="colors"
      :label-colors="labelColors"
      :numeric="numericFields.includes('requirements')"
      icon="hot_tub"
      label="Pitää olla"
      multiple
    />
  </div>
</template>

<script>
import {
  additional_property_types,
  requirements,
  property_types,
  target_types,
} from '@/components/searchWatch/data';

export default {
  name: 'HelmiSearchWatchFields',

  components: {
    'helmi-chips': () => import('@/components/formElements/Chips'),
    'helmi-range-slider': () => import('@/components/formElements/RangeSlider'),
    'helmi-combo-box': () => import('@/components/formElements/ComboBox'),
  },

  props: {
    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    labelColors: {
      type: Object,
      default: () => null,
    },

    items: {
      type: Object,
      default: () => ({}),
    },

    numericFields: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    additional_property_types,
    requirements,
    property_types,
    target_types,
  }),

  computed: {
    maxPrice() {
      return this.items.target_type === 'rental' ? 5000 : 1000000;
    },

    stepOptionsPrice() {
      return this.items.target_type === 'rental'
        ? { limit: 1000, step: [10, 50] }
        : { limit: 200000, step: [10000, 50000] };
    },

    stepPrice() {
      return this.items.target_type === 'rental' ? 50 : 10000;
    },
  },

  mounted() {
    // merge cities and zips
    this.items.cities = [
      ...this.items.cities?.split(',') || [],
      ...this.items.zips?.split(',') || [],
    ].join(',');

    this.items.area = {
      area_min: parseInt(this.items.area_min, 10),
      area_max: parseInt(this.items.area_max, 10),
    };

    this.items.price = {
      price_min: parseInt(this.items.price_min, 10),
      price_max: parseInt(this.items.price_max, 10),
    };

    this.items.rooms = {
      rooms_min: parseInt(this.items.rooms_min, 10),
      rooms_max: parseInt(this.items.rooms_max, 10),
    };
  },
};
</script>

<style lang="scss">
.helmi-search-watch-fields {

}
</style>
